import { userConstants } from "../constants";
const initialState = { emailData: [] };

export function searchEmailData(state = initialState, action) {
  console.log("state", initialState, "action", action);
  switch (action.type) {
    case "EMAIL_DATA":
      console.log("THIS IS INSIDE EMAILdATA.REDUCER");
      return {
        emailData: action.data,
      };
    case "RESET_EMAIL_DATA":
      return {
        emailData: null,
      };
    case userConstants.SET_BLOCKING_STATE:
      return { blocking: action.payload };
    case userConstants.SET_DELETE_STATE:
      return { deleteStatus: action.payload };
    case userConstants.SET_CREATE_STATE:
      return { createStatus: action.payload };
    case userConstants.UPDATE_AUDITOR_DATA:
      return { auditorUser: action.data };
    default:
      return state;
  }
}
